import { clsModel, fnCreate } from '@cls/clsModel'
import { employees as api } from '@/app/api'
import string from '@lib/string'

var modelName = "employee_tariff";
const fields = ["id_employee", "id_tariff", "name", "amount_intern", "amount_extern"];
const mandatoryFields = [];

class clsEmployeeTariff extends clsModel {
    
    id_employee           = null;
    id_tariff             = null; 
    amount_intern         = null;
    amount_extern         = null;
    name                  = null;

    // Is this a new record?
    get isNew() {
        return false;
    }
    
    get modelRep() {
        return this.name;
    }

    /**
     * The default api load implementation just loads the data via the api with the id.
     * Override this method for example to load the data via other parameters (e.g. id_employee, id_tariff). 
     */
    apiLoad(id, params) {
        // 
        return this.api.loadTariff(params.id_employee, params.id_tariff);
    }
    /**
     * The default api save implementation just calls save on the api.
     * Override this method for example to call another save method.
     */
    apiSave(data) {
        return this.api.saveTariff(data);
    }
    
    fill(data) {
        data = data ||{};
        data.amount_intern    = data.amount_intern    || 0;
        data.amount_extern      = data.amount_extern      || 0;
        let result = super.fill(data);
        return result;
    }
    
    constructor() {
        super({
          api: api,   
          modelName: modelName, 
          mandatoryFields: mandatoryFields,

          fillable: fields
        })
    } 
        
 }
 export default fnCreate(clsEmployeeTariff , 'clsEmployeeTariff');
